import LoggingIcon from '@mui/icons-material/EmojiPeopleTwoTone';
import LoggingEventsList from './LoggingEventsList';


export default {
    list: LoggingEventsList,
    icon: LoggingIcon
}